module.exports = __webpack_public_path__ + "img/P13-zh.46c4c138.png";